import {
  FRAuth,
  Config,
  FRUser,
  TokenManager,
  UserManager,
} from '@forgerock/javascript-sdk'
import { getQueryParams } from '.'
import { ERROR_MESSAGES } from './errorMessages'

export const SocialLogin = (providerId) => {
  const FATAL = 'Fatal'
  const BASEURL = process.env.REACT_APP_FR_BASE_URL
  const REDIRECTURI = process.env.REACT_APP_FR_SUCCESS_CALLBACK
  const TREENAME = process.env.REACT_APP_FR_LOGIN_TREENAME
  Config.set({
    clientId: 'AENDrupalClient', // e.g. 'ForgeRockSDKClient'
    redirectUri: REDIRECTURI, // e.g. 'https://sdkapp.example.com:8443/_callback'
    scope: 'openid profile email', // e.g. 'openid profile me.read'
    serverConfig: {
      baseUrl: BASEURL, // e.g. 'https://openam.example.com:9443/openam/'
      timeout: 90000, // 90000 or less
    },
    realmPath: 'AENMobile', // e.g. 'root'
    tree: TREENAME, // e.g. 'Login'
    tokenStore: 'sessionStorage',
  })

  const showUser = (user) => {
    document.querySelector('#User pre').innerHTML = JSON.stringify(
      user,
      null,
      2
    )
    const panel = document.querySelector('#User')
    panel.querySelector('.btnhidden').addEventListener('click', () => {
      logout()
    })
    showStep('User')
  }

  // Show only the view for this handler
  const showStep = (handler) => {
    return true
  }

  const socialLoginHandler = async (step) => {
    const RedirectCallbacks = step.getCallbacksOfType('RedirectCallback')
    if (RedirectCallbacks.length) {
      FRAuth.redirect(step)
    } else {
      const StringAttributeInputCallbacks = step.getCallbacksOfType(
        'StringAttributeInputCallback'
      )
      if (StringAttributeInputCallbacks.length) {
        const StringAttributeInputCallback = step.getCallbackOfType(
          'StringAttributeInputCallback'
        )
        StringAttributeInputCallback.setValue('WEB')
        nextStep(step)
      } else {
        const cb = step.getCallbackOfType('SelectIdPCallback')
        window.localStorage.setItem('providerLast', providerId)
        cb.setProvider(providerId)
        nextStep(step)
      }
    }
  }

  const handleStepLogin = async (step) => {
    console.log(`step`, step)
    switch (step.type) {
      case 'LoginSuccess':
        document.body.classList.add('login-success-temp')

        window.location.href.indexOf('maggiortutela') > -1
          ? (window.location.href =
              process.env.REACT_APP_NEW_AREA_MERCATO_TUTELA_AUTH)
          : (window.location.href =
              process.env.REACT_APP_NEW_AREA_MERCATO_LIBERO_AUTH)
        return

      case 'LoginFailure':
        showStep('Error')
        let inputs = document.querySelectorAll('input')
        inputs.forEach((input) => input.classList.add('error'))
        if (step.getMessage().indexOf('Locked Out')) {
          document.querySelector('#Error span').innerHTML =
            ERROR_MESSAGES.userLockedOut
        } else {
          document.querySelector('#Error span').innerHTML =
            step.getDescription()
        }
        return

      default:
        const urlSearchParams = new URLSearchParams(window.location.search)
        const params = Object.fromEntries(urlSearchParams.entries())
        if ((params.code && params.state) || params.form_post_entry) {
          let step = FRAuth.resume(window.location.href)
          window.history.pushState({}, document.title, window.location.pathname)
          nextStep(step)
        } else {
          socialLoginHandler(step)
        }
    }
  }

  const nextStep = (step) => {
    FRAuth.next(step).then(handleStepLogin)
  }

  const logout = async () => {
    try {
      await FRUser.logout()
      window.location.reload(true)
    } catch (error) {
      console.error(error)
    }
  }

  const urlSearchParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(urlSearchParams.entries())
  console.log('params', params)
  if ((params.code && params.state) || params.form_post_entry) {
    let step = FRAuth.resume(window.location.href)
    nextStep(step)
  } else {
    nextStep()
  }
}
